import { computed } from "vue";
import { globals } from "@/core/globals";
import { useUser } from "./useUser";

const { user } = useUser();

const organization = computed(() => user.value?.contact?.organizations?.items?.[0]);

// Inverse of the currency -> data area id mapping used across the app.
const DATA_AREA_ID_TO_CURRENCY: Record<string, string> = {
  THO: "USD",
  MUC: "EUR",
  FRA: "EUR",
  UK0: "GBP",
  SWE: "SEK",
  JPN: "JPY",
  PRC: "CNY",
  BRA: "BRL",
};

// Whether the current user belongs to a channel-partner organization (and the store-level kill switch is on)
const isChannelPartner = computed(
  () => globals.channelPartnerOrdersEnabled === true && organization.value?.isChannelPartnerTL === true,
);

// Destination data area id the CP's orders are swapped to (e.g. "JPN"). Stored on destinationDataAreaIdTL.
const destinationDataAreaId = computed(() => organization.value?.destinationDataAreaIdTL ?? null);

// Currency of the destination region, used for region content and warehouse/availability selection.
const operationalCurrency = computed(() =>
  destinationDataAreaId.value ? DATA_AREA_ID_TO_CURRENCY[destinationDataAreaId.value] ?? null : null,
);

export function useChannelPartner() {
  return {
    isChannelPartner,
    destinationDataAreaId,
    operationalCurrency,
  };
}
